/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box, Grid } from '@mui/material';
import {
  DatePickerV2,
  InputV2,
  NumberInputV2,
  TrueFalseSelectV2,
  WidgetV2,
} from '../../../components/v2';
import * as actionsNsirs from '../../../store/nsir/actions';

const FinanceiroTab = ({ nsir, isAdmin, updateFinanceiro, nsirTitle }) => {
  const [values, setValues] = useState({});

  useEffect(() => {
    if (nsir && nsir.id) {
      setValues({
        id: nsir.id,
        usProgramada: nsir.usProgramada,
        usExecutada: nsir.usExecutada,
        usPaga: nsir.usPaga,
        nsirPaga: nsir.nsirPaga,
        apro: nsir.apro,
        hd: nsir.hd,
        nsirPagaInspetor: nsir.nsirPagaInspetor,
        dataPagamento: nsir.dataPagamento,
        observacaoFinanceiro: nsir.observacaoFinanceiro,
        dataPeriodoMedicao: nsir.dataPeriodoMedicao,
        dataAtualizacaoPeriodoMedicaoValue: nsir.dataAtualizacaoPeriodoMedicaoValue,
      });
    }
  }, [nsir]);

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const getActions = () => {
    return [{
      onClick: () => updateFinanceiro({
        ...values,
        dataPagamento: values.dataPagamento ? values.dataPagamento : null,
        dataPeriodoMedicao: values.dataPeriodoMedicao ?? null,
      }, response => {
        setValues({ ...values, dataAtualizacaoPeriodoMedicaoValue: response.dataAtualizacaoPeriodoMedicaoValue });
      }),
      title: 'Salvar',
      show: isAdmin
    }];
  };

  return (
    <WidgetV2 title={`Financeiro > ${nsirTitle}`} actions={getActions()}>
      <Box sx={{ p: 2, pt: 2.5, pb: 3.75 }}>
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, sm: 2 }}>
            <NumberInputV2
              label="US Programada"
              name="usProgramada"
              onChange={valor => setValues({
                ...values,
                usProgramada: valor
              })}
              value={values.usProgramada}
              format="##,###"
              decimalScale={3}
              prefix=""
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 2 }}>
            <NumberInputV2
              label="US Executada"
              name="usExecutada"
              onChange={valor => setValues({
                ...values,
                usExecutada: valor
              })}
              value={values.usExecutada}
              disabled={!isAdmin}
              format="##,###"
              decimalScale={3}
              prefix=""
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 2 }}>
            <NumberInputV2
              label="US Apropriada"
              name="usPaga"
              onChange={valor => setValues({
                ...values,
                usPaga: valor
              })}
              value={values.usPaga}
              disabled={!isAdmin}
              format="##,###"
              decimalScale={3}
              prefix=""
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <NumberInputV2
              label="APRO"
              name="apro"
              onChange={valor => setValues({
                ...values,
                apro: valor
              })}
              value={values.apro}
              disabled={!isAdmin}
              decimalScale={0}
              prefix=""
              thousandSeparator=""
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <NumberInputV2
              label="HD"
              name="hd"
              onChange={valor => setValues({
                ...values,
                hd: valor
              })}
              value={values.hd}
              disabled={!isAdmin}
              decimalScale={0}
              prefix=""
              thousandSeparator=""
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <DatePickerV2
              label="Período de Referencia da Medição"
              onChange={data => setValues({ ...values, dataPeriodoMedicao: data })}
              value={values.dataPeriodoMedicao || null}
              showInput
              yearMonth
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <InputV2
              label="Atualização Período de Referencia"
              value={values.dataAtualizacaoPeriodoMedicaoValue || ''}
              disabled
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <TrueFalseSelectV2
              showEmpty={false}
              label="Nsir Paga ao Inspetor/Ajudante"
              name="nsirPagaInspetor"
              onChange={handleChange}
              value={values.nsirPagaInspetor || false}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <DatePickerV2
              label="Data do Pagamento"
              onChange={data => setValues({
                ...values,
                dataPagamento: data
              })}
              value={values.dataPagamento || null}
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <InputV2
              label="Observação"
              name="observacaoFinanceiro"
              onChange={handleChange}
              value={values.observacaoFinanceiro}
              rows={4}
              multiline
              disabled={!isAdmin}
            />
          </Grid>
        </Grid>
      </Box>
    </WidgetV2>
  );
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...actionsNsirs
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(FinanceiroTab);
